<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <!-- This part is for rendering bill number list to search for bill wise purchase return data -->
      <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="this.loadPage">
          <div class="p-field p-col-12 p-md-2">
            <label for="billNumber">Bill Number</label>
            <dropdown
            v-model="billNo"
            :options="billNumberList"
            optionLabel="billNo"
            placeholder="Select Bill No"
            :showClear="true"></dropdown>
          </div>
        <div class="p-field p-col-12 p-md-1 p-mt-5">
          <Button class="p-button-raised p-button-rounded" @click="searchInventoryDetailsByBillNo" label="Search" icon="pi pi-search"/>
        </div>
      </div>
      <!-- This part is for rendering bill number list to search for bill wise purchase return data -->
      <div v-if="!this.loadPage">
        <form >
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <label for="returnDate">Return Date</label>
                <date-picker v-model="returnDate" valueType="format"
                  v-if="!englishDateEnabled"
                />
                <InputText ref="tran" v-else class="nepali-calendar" id="returnDate" v-model="returnDate"
                />
              </div>

              <div class="p-field p-col-12 p-md-2">
                <label for="purchaseSalesDate">Date</label>
                <date-picker v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled" disabled
                />
                <InputMask mask="9999-99-99" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"
                disabled
                />
              </div>

              <div class="p-field p-col-12 p-md-2">
                <label for="billNo">Bill No</label>
                <InputText id="billNo" v-model="billNo" disabled />
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="refno">Return No.</label>
                <InputText id="refno" v-model="returnNo" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="purType">Pur Type</label>
                <select class="form-control" v-model="taxType" disabled>
                  <option selected disabled value>Select One</option>
                  <option v-for="(tax,ind) in taxTypeList" :key="ind">{{tax.name}}</option>
                </select>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                    <label>Vendor</label>
                        <Dropdown
                        v-model="accountMaster"
                        :options="supplierCustomerCashList"
                        optionLabel="name"
                        :filter="true"
                        placeholder="Select Account"
                        :showClear="true"
                        disabled
                        />
                 </div>
                 <div class="p-field p-col-12 p-md-2" v-show="ifCash">
                    <label>Supplier</label>
                    <InputText v-if="accountMaster.contactName!=undefined" placeholder="Vendor Name"
                     v-model="accountMaster.contactName" disabled/>
                    <InputText v-else placeholder="Vendor Name" v-model="vendorName"/>
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="warehouse">Store</label>
                    <Dropdown
                    v-model="warehouse"
                    :options="warehouseLists"
                    optionLabel="name"
                    :filter="true"
                    placeholder="Select store"
                    disabled
                    :showClear="true"
                    />
                </div>
            </div>
              <div class="p-field p-col-12 p-md-2" v-if="!ifNotCash || accountMaster.id > 0">
                  <label for="panNo">Tax No:</label>
                  <b style="margin-right:10px">{{accountMaster.panNo}}</b>
                  <label for="panNo">Cur. Bal:</label>
                  <b style="color:red;" v-if="accountMaster.closingBalance>0">
                    {{(accountMaster.closingBalance).toFixed(2) + 'Cr'}}
                  </b>
                  <b style="color:green;" v-else>
                    {{(accountMaster.closingBalance*(-1)).toFixed(2) + 'Dr'}}
                  </b>
                </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
              <div class="scrollable">
                  <table class="table table-bordered">
                    <thead >
                      <tr>
                        <th>SN</th>
                        <th>Item Name</th>
                        <th>Purchased Qty</th>
                        <th>Remaining Qty</th>
                        <th>Return Qty</th>
                        <th>Unit</th>
                        <th>Rate</th>
                        <th>Amount</th>
                        <!-- <th scope="col">Action</th> -->
                      </tr>
                    </thead>
                    <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index" >
                      <tr>
                        <td>{{index+1}}</td>
                        <td>{{item.itemMaster.name}}</td>
                        <td>{{item.quantity}}</td>
                        <td>{{item.quantity - item.returnQty}}</td>
                        <td style="text-align:right">
                          <InputText v-model="item.returnQty" /></td>
                        <td style="text-align:right">{{item.itemMaster.unitName}}</td>
                        <td style="text-align:right">{{item.rate}}</td>
                        <td style="text-align:right">{{item.rate * item.quantity}} </td>
                      </tr>
                    </tbody>
                </table>
              </div>
                <!-- <hr> -->
                <!-- <div class="container-fluid">
                  <div class="row">
                  <div class="col-md-2">
                    <b style="margin-left: 15em;">Total:</b>
                  </div>
                  <div class="col-md-2">
                    <b style="margin-left: 16em;">{{totalQty}}</b>
                  </div>
                  <div>
                    <b style="margin-left: 38em;">{{subTotal}}</b>
                  </div>
                  </div>
                </div> -->
                <hr>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-4">
                <label for="narration">Narration</label>
                <Textarea id="narration" rows="6" v-model="narration" disabled/>
            </div>
             <div class="p-field p-col-12 p-md-4">
                <label for="narration">Return Reason</label>
                <Textarea id="narration" rows="6" v-model="returnReason"/>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-6"></div>
            <div class="p-field p-col-12 p-md-1">
              <Button class="p-button-raised p-button-success"
              @click.prevent="addPurchaseReturnBillWise" :label="!editing ? 'Save': 'Update'" icon="pi pi-save"/>
            </div>
              <div class="p-field p-col-12 p-md-1">
                <Button class="p-button-raised p-button-danger" @click="goBack" label="Cancel"/>
              </div>
              <div class="p-field p-col-12 p-md-1">
                <Button class="p-button-raised p-button-secondary" label="Print" icon="pi pi-print"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <Button class="p-button-raised p-button-secondary" icon="pi pi-download" label="Generate PDF"/>
              </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
export default {
  data() {
    return {
      billNumberList: [],
      returnDate: new Date().toISOString().slice(0, 10),
      purchaseSalesDate: new Date().toISOString().slice(0, 10),
      loadPage: true,
      billNo: '',
      returnNo: null,
      loading: false,
      accountMaster: '',
      warehouse: '',
      taxType: '',
      refNo: '',
      returnQty: '',
      narration: '',
      returnReason: '',
      editing: false,
      inventoryHeaderId: null,
      taxTypeList: [
        {name: 'Exclusive', code: 'Exclusive'},
        {name: 'Inclusive', code: 'Inclusive'},
        {name: 'Exempt', code: 'Exempt'}
      ],
      message: '',
      messageType: '',
      show: false,
      purchaseDetailList: [],
      inventoryInOutDetailList: [],
      englishDateEnabled: true,
      vendorName: ''
    }
  },
  mounted() {
    this.billNumbers()
    this.supplierCustomerList()
    this.warehouseList()
    this.maxPurchaseReturnNo()
  },
  computed: {
    supplierCustomerCashList() {
      return this.$store.state.accountMaster.supplierCustomerCashList
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    ifCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
        return true
      }
    },
    ifNotCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
        return true
      }
    }
  },
  methods: {
    async billNumbers() {
      let response = await this.$store.dispatch('purchaseBillNumber')
      this.billNumberList = response.data.data
    },
    async maxPurchaseReturnNo() {
      let response = await this.$store.dispatch('maxPurchaseReturnNumber')
      this.returnNo = response.data.data
    },
    async searchInventoryDetailsByBillNo() {
      this.loadPage = false
      this.loading = !this.loading
      let response = await this.$store.dispatch('inventoryDetailsByBillNo', this.billNo.billNo)
      this.loading = false
      this.purchaseDetailList = response.data.data
      if (this.purchaseDetailList.length > 0) {
        this.purchaseDetailList.forEach(data => {
          this.billNo = data.billNo
          this.inventoryHeaderId = data.id
          this.purchaseSalesDate = data.purchaseDate
          this.refNo = data.referenceNumber
          this.accountMaster = data.accountMaster
          this.warehouse = data.warehouse
          this.narration = data.remarks
          this.taxType = data.vatTypeEnum
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
      this.setDate()
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierCustomerAndCashList')
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    updateInventoryDetails(id) {
      this.inventoryInOutDetailList.forEach(invDetail => {
        if (invDetail.id === id) {
          invDetail.returnQty = this.returnQty
        }
      })
    },
    async addPurchaseReturnBillWise() {
      if (this.returnDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      if (this.returnReason.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Return reason cannot be empty!', life: 10000})
        return
      }
      let returnObject = {
        inventoryHeaderId: this.inventoryHeaderId,
        returnNo: this.returnNo,
        billNo: this.billNo,
        warehouseId: this.warehouse.id,
        accountMasterId: this.accountMaster.id,
        purchaseSalesDateNepali: this.returnDate,
        purchaseSalesDate: this.returnDate,
        fiscalYearId: this.$store.state.fyId,
        taxType: this.taxType,
        remarks: this.narration,
        billToName: this.vendorName,
        applyExpensesOnBill: this.applyExpensesOnBill,
        transactionDate: this.returnDate,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        returnReason: this.returnReason
      }
      let response = await this.$store.dispatch('purchaseReturnBillWise', returnObject)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
      this.goBack()
    },
    reset() {
      this.billNo = ''
    },
    setDate() {
      if (!this.loadPage) {
        this.checkEnglish()
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.nepaliDate()
        }
        if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
          this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        }
        if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
          this.setEnglishDate()
        }
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        this.returnDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      this.returnDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
      $('#returnDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.returnDate = $('#returnDate').val()
        }
      })
    },
    goBack() {
      this.loadPage = true
      this.returnQty = ''
    }
  },
  components: {
    Dropdown,
    DatePicker,
    InputMask,
    Textarea,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// purchaseReturnBillWise.vue?69ce6c09